


  
  

  var faBasketball = {
    prefix: 'far',
    iconName: 'basketball',
    icon: [
      512,
      512,
      [127936,"basketball-ball"],
      'f434',
      
      'M304 458.4c0-.8 0-1.6 0-2.4 0-33.3 10.7-64.1 28.9-89.2l52.2 52.2c-23.5 18.6-51 32.2-81.1 39.4zM256.2 464l-.2 0c-48.8 0-93.7-16.8-129.1-44.9L256 289.9 298.6 332.6c-26.7 34-42.6 76.9-42.6 123.4 0 2.7 .1 5.3 .2 8zm76.4-165.4L289.9 256 419.1 126.9C447.2 162.3 464 207.2 464 256l0 .2c-2.7-.1-5.3-.2-8-.2-46.6 0-89.4 15.9-123.4 42.6zM458.4 304c-7.1 30.1-20.8 57.7-39.4 81.1l-52.2-52.2c25-18.2 55.9-28.9 89.2-28.9 .8 0 1.6 0 2.4 0zM256 222.1l-42.6-42.6c26.7-34 42.6-76.9 42.6-123.4 0-2.7-.1-5.3-.2-8l.2 0c48.8 0 93.7 16.8 129.1 44.9L256 222.1zm-76.9-76.9L126.9 92.9c23.5-18.6 51-32.2 81.1-39.4 0 .8 0 1.6 0 2.4 0 33.3-10.7 64.1-28.9 89.2zm-33.9 33.9c-25 18.2-55.9 28.9-89.2 28.9-.8 0-1.6 0-2.4 0 7.1-30.1 20.8-57.7 39.4-81.1l52.2 52.2zM48 255.8c2.7 .1 5.3 .2 8 .2 46.6 0 89.4-15.9 123.4-42.6L222.1 256 92.9 385.1C64.8 349.7 48 304.8 48 256l0-.2zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512z'
      
    ]
  };

  
    var faBasketballBall = faBasketball;
  

  
  

  var faCalendarDays = {
    prefix: 'far',
    iconName: 'calendar-days',
    icon: [
      448,
      512,
      ["calendar-alt"],
      'f073',
      
      'M120 0c13.3 0 24 10.7 24 24l0 40 160 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 32 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64l32 0 0-40c0-13.3 10.7-24 24-24zM384 432c8.8 0 16-7.2 16-16l0-64-88 0 0 80 72 0zm16-128l0-80-88 0 0 80 88 0zm-136 0l0-80-80 0 0 80 80 0zm-128 0l0-80-88 0 0 80 88 0zM48 352l0 64c0 8.8 7.2 16 16 16l72 0 0-80-88 0zm136 0l0 80 80 0 0-80-80 0zM120 112l-56 0c-8.8 0-16 7.2-16 16l0 48 352 0 0-48c0-8.8-7.2-16-16-16l-264 0z'
      
    ]
  };

  
    var faCalendarAlt = faCalendarDays;
  

  
  

  var faCardsBlank = {
    prefix: 'far',
    iconName: 'cards-blank',
    icon: [
      512,
      512,
      [],
      'e4df',
      
      'M454.7 64.4c32.3 3.3 57.5 30.5 57.5 63.7l0 320-.3 6.5c-3.1 30.1-27 54.1-57.1 57.1l-6.5 .3-192 0-6.5-.3c-12.1-1.2-23.1-5.9-32.2-12.8l130-34.8 100.8 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16l-70.7 0-12.8-48 83.5 0 6.5 .3zM233.3-18.6c32-5.2 63.4 14.6 72 46.6l82.8 309.1 1.4 6.4c4.8 29.9-12.1 59.2-40.4 70l-6.2 2-185.5 49.7-6.4 1.3c-29.9 4.8-59.2-12.1-70-40.4l-2-6.2-82.8-309.1c-8.6-32 8.7-64.8 39-76.3l6.2-2 185.5-49.7 6.4-1.4zm6 47.8L53.9 78.9c-8.5 2.3-13.6 11.1-11.3 19.6l82.8 309.1c2.3 8.5 11.1 13.6 19.6 11.3l185.4-49.7c8.5-2.3 13.6-11.1 11.3-19.6L258.9 40.5c-2.3-8.5-11.1-13.6-19.6-11.3z'
      
    ]
  };

  

  
  

  var faChartNetwork = {
    prefix: 'far',
    iconName: 'chart-network',
    icon: [
      640,
      512,
      [],
      'f78a',
      
      'M224 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 88c1.1 0 2.2 0 3.3-.1l26.9 57.6c-31.3 21.7-53.7 55.4-60.2 94.5l-70.6 0c-9.5-23.5-32.5-40-59.3-40-35.3 0-64 28.7-64 64s28.7 64 64 64c26.9 0 49.9-16.5 59.3-40l70.6 0c11.4 68.1 70.7 120 142 120 43.8 0 83-19.5 109.4-50.4l67.4 40.4c-.5 3.2-.8 6.6-.8 9.9 0 35.3 28.7 64 64 64s64-28.7 64-64-28.7-64-64-64c-14.5 0-27.8 4.8-38.5 12.9l-67.3-40.4c6.4-16.3 9.9-34 9.9-52.5 0-23.2-5.5-45.2-15.3-64.6l77.6-56.9c9.8 6.1 21.3 9.6 33.7 9.6 35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64c0 5.4 .7 10.7 1.9 15.7l-77.6 56.9c-25.9-25.2-61.3-40.7-100.3-40.7-13.3 0-26.1 1.8-38.3 5.2l-26.9-57.5C281.5 96.2 288 80.9 288 64 288 28.7 259.3 0 224 0s-64 28.7-64 64 28.7 64 64 64zm352-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM552 448a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM64 280a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm272-72a96 96 0 1 1 0 192 96 96 0 1 1 0-192z'
      
    ]
  };

  

  
  

  var faCircleXmark = {
    prefix: 'far',
    iconName: 'circle-xmark',
    icon: [
      512,
      512,
      [61532,"times-circle","xmark-circle"],
      'f057',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM167 167c-9.4 9.4-9.4 24.6 0 33.9l55 55-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55-55-55c-9.4-9.4-24.6-9.4-33.9 0z'
      
    ]
  };

  
    var faTimesCircle = faCircleXmark;
  
    var faXmarkCircle = faCircleXmark;
  

  
  

  var faClipboard = {
    prefix: 'far',
    iconName: 'clipboard',
    icon: [
      384,
      512,
      [128203],
      'f328',
      
      'M232 96l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24zm0 48c37.1 0 67.6-28 71.6-64L320 80c8.8 0 16 7.2 16 16l0 352c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l16.4 0c4 36 34.5 64 71.6 64l80 0zM291.9 32C279 12.7 257 0 232 0L152 0c-25 0-47 12.7-59.9 32L64 32C28.7 32 0 60.7 0 96L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-352c0-35.3-28.7-64-64-64l-28.1 0z'
      
    ]
  };

  

  
  

  var faClone = {
    prefix: 'far',
    iconName: 'clone',
    icon: [
      512,
      512,
      [],
      'f24d',
      
      'M288 464L64 464c-8.8 0-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16l48 0 0-48-48 0c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-48-48 0 0 48c0 8.8-7.2 16-16 16zM224 304c-8.8 0-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16l-224 0zm-64-16c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L224 0c-35.3 0-64 28.7-64 64l0 224z'
      
    ]
  };

  

  
  

  var faCopy = {
    prefix: 'far',
    iconName: 'copy',
    icon: [
      448,
      512,
      [],
      'f0c5',
      
      'M384 336l-192 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l133.5 0c4.2 0 8.3 1.7 11.3 4.7l58.5 58.5c3 3 4.7 7.1 4.7 11.3L400 320c0 8.8-7.2 16-16 16zM192 384l192 0c35.3 0 64-28.7 64-64l0-197.5c0-17-6.7-33.3-18.7-45.3L370.7 18.7C358.7 6.7 342.5 0 325.5 0L192 0c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-16-48 0 0 16c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l16 0 0-48-16 0z'
      
    ]
  };

  

  
  

  var faExpand = {
    prefix: 'far',
    iconName: 'expand',
    icon: [
      448,
      512,
      [],
      'f065',
      
      'M136 32c13.3 0 24 10.7 24 24s-10.7 24-24 24l-88 0 0 88c0 13.3-10.7 24-24 24S0 181.3 0 168L0 56C0 42.7 10.7 32 24 32l112 0zM0 344c0-13.3 10.7-24 24-24s24 10.7 24 24l0 88 88 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 480c-13.3 0-24-10.7-24-24L0 344zM424 32c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-88-88 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l112 0zM400 344c0-13.3 10.7-24 24-24s24 10.7 24 24l0 112c0 13.3-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l88 0 0-88z'
      
    ]
  };

  

  
  

  var faEye = {
    prefix: 'far',
    iconName: 'eye',
    icon: [
      576,
      512,
      [128065],
      'f06e',
      
      'M288 80C222.8 80 169.2 109.6 128.1 147.7 89.6 183.5 63 226 49.4 256 63 286 89.6 328.5 128.1 364.3 169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256 513 226 486.4 183.5 447.9 147.7 406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1 3.3 7.9 3.3 16.7 0 24.6-14.9 35.7-46.2 87.7-93 131.1-47.1 43.7-111.8 80.6-192.6 80.6S142.5 443.2 95.4 399.4c-46.8-43.5-78.1-95.4-93-131.1-3.3-7.9-3.3-16.7 0-24.6 14.9-35.7 46.2-87.7 93-131.1zM288 336c44.2 0 80-35.8 80-80 0-29.6-16.1-55.5-40-69.3-1.4 59.7-49.6 107.9-109.3 109.3 13.8 23.9 39.7 40 69.3 40zm-79.6-88.4c2.5 .3 5 .4 7.6 .4 35.3 0 64-28.7 64-64 0-2.6-.2-5.1-.4-7.6-37.4 3.9-67.2 33.7-71.1 71.1zm45.6-115c10.8-3 22.2-4.5 33.9-4.5 8.8 0 17.5 .9 25.8 2.6 .3 .1 .5 .1 .8 .2 57.9 12.2 101.4 63.7 101.4 125.2 0 70.7-57.3 128-128 128-61.6 0-113-43.5-125.2-101.4-1.8-8.6-2.8-17.5-2.8-26.6 0-11 1.4-21.8 4-32 .2-.7 .3-1.3 .5-1.9 11.9-43.4 46.1-77.6 89.5-89.5z'
      
    ]
  };

  

  
  

  var faEyeSlash = {
    prefix: 'far',
    iconName: 'eye-slash',
    icon: [
      576,
      512,
      [],
      'f070',
      
      'M41-24.9c-9.4-9.4-24.6-9.4-33.9 0S-2.3-.3 7 9.1l528 528c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-96.4-96.4c2.7-2.4 5.4-4.8 8-7.2 46.8-43.5 78.1-95.4 93-131.1 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1-47.1-43.7-111.8-80.6-192.6-80.6-56.8 0-105.6 18.2-146 44.2L41-24.9zM176.9 111.1c32.1-18.9 69.2-31.1 111.1-31.1 65.2 0 118.8 29.6 159.9 67.7 38.5 35.7 65.1 78.3 78.6 108.3-13.6 30-40.2 72.5-78.6 108.3-3.1 2.8-6.2 5.6-9.4 8.4L393.8 328c14-20.5 22.2-45.3 22.2-72 0-70.7-57.3-128-128-128-26.7 0-51.5 8.2-72 22.2l-39.1-39.1zm182 182l-108-108c11.1-5.8 23.7-9.1 37.1-9.1 44.2 0 80 35.8 80 80 0 13.4-3.3 26-9.1 37.1zM103.4 173.2l-34-34c-32.6 36.8-55 75.8-66.9 104.5-3.3 7.9-3.3 16.7 0 24.6 14.9 35.7 46.2 87.7 93 131.1 47.1 43.7 111.8 80.6 192.6 80.6 37.3 0 71.2-7.9 101.5-20.6L352.2 422c-20 6.4-41.4 10-64.2 10-65.2 0-118.8-29.6-159.9-67.7-38.5-35.7-65.1-78.3-78.6-108.3 10.4-23.1 28.6-53.6 54-82.8z'
      
    ]
  };

  

  
  

  var faFileCirclePlus = {
    prefix: 'far',
    iconName: 'file-circle-plus',
    icon: [
      576,
      512,
      [58606],
      'e494',
      
      'M208 48L96 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16l154.9 0c6.1 17.3 14.6 33.4 25.1 48L96 512c-35.3 0-64-28.7-64-64L32 64C32 28.7 60.7 0 96 0L229.5 0c17 0 33.3 6.7 45.3 18.7L397.3 141.3c12 12 18.7 28.3 18.7 45.3l0 21.5-136 0c-39.8 0-72-32.2-72-72l0-88zM348.1 160L256 67.9 256 136c0 13.3 10.7 24 24 24l68.1 0zM432 256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48z'
      
    ]
  };

  

  
  

  var faGrid2 = {
    prefix: 'far',
    iconName: 'grid-2',
    icon: [
      448,
      512,
      [],
      'e196',
      
      'M48 80l0 96 96 0 0-96-96 0zM0 80C0 53.5 21.5 32 48 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48L0 80zM48 336l0 96 96 0 0-96-96 0zM0 336c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96zM400 80l-96 0 0 96 96 0 0-96zM304 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zm0 304l0 96 96 0 0-96-96 0zm-48 0c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96z'
      
    ]
  };

  

  
  

  var faImage = {
    prefix: 'far',
    iconName: 'image',
    icon: [
      448,
      512,
      [],
      'f03e',
      
      'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm128 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm136 72c8.5 0 16.4 4.5 20.7 11.8l80 136c4.4 7.4 4.4 16.6 .1 24.1S352.6 384 344 384l-240 0c-8.9 0-17.2-5-21.3-12.9s-3.5-17.5 1.6-24.8l56-80c4.5-6.4 11.8-10.2 19.7-10.2s15.2 3.8 19.7 10.2l17.2 24.6 46.5-79c4.3-7.3 12.2-11.8 20.7-11.8z'
      
    ]
  };

  

  
  

  var faImages = {
    prefix: 'far',
    iconName: 'images',
    icon: [
      576,
      512,
      [],
      'f302',
      
      'M480 80c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16l-320 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l320 0zM160 32c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L160 32zm80 112a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm140.7 3.8c-4.3-7.3-12.2-11.8-20.7-11.8s-16.4 4.5-20.7 11.8l-46.5 79-17.2-24.6c-4.5-6.4-11.8-10.2-19.7-10.2s-15.2 3.8-19.7 10.2l-56 80c-5.1 7.3-5.8 16.9-1.6 24.8S191.1 320 200 320l240 0c8.6 0 16.6-4.6 20.8-12.1s4.2-16.7-.1-24.1l-80-136zM48 152c0-13.3-10.7-24-24-24S0 138.7 0 152L0 448c0 35.3 28.7 64 64 64l360 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L64 464c-8.8 0-16-7.2-16-16l0-296z'
      
    ]
  };

  

  
  

  var faLanguage = {
    prefix: 'far',
    iconName: 'language',
    icon: [
      576,
      512,
      [],
      'f1ab',
      
      'M168 0c13.3 0 24 10.7 24 24l0 56 136 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16.2 0-16.5 38.4c-18.6 43.5-45.2 82.8-77.9 116 13.9 9.2 28.6 17.4 44 24.4l60.9 27.9 71.8-160.5C398 165.6 406.5 160 416 160s18 5.6 21.9 14.2l136 304c5.4 12.1 0 26.3-12.1 31.7s-26.3 0-31.7-12.1l-29.4-65.8-169.3 0-29.4 65.8c-5.4 12.1-19.6 17.5-31.7 12.1s-17.5-19.6-12.1-31.7l44.6-99.7-61.3-28.1c-21.5-9.9-41.9-21.7-60.9-35.2-17.5 13.6-36.3 25.7-56.2 36.1L67.1 381.3c-11.7 6.2-26.2 1.6-32.4-10.1s-1.6-26.2 10.1-32.4L102 308.8c14-7.3 27.4-15.7 40.1-24.8-27.5-25.6-51.1-55.2-70-88-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8c17.4 30.3 39.5 57.5 65.4 80.7 30.5-29.8 55.1-65.5 72.2-105.3L259.6 128 24 128c-13.3 0-24-10.7-24-24S10.8 80 24 80l120 0 0-56c0-13.3 10.7-24 24-24zM479.2 384L416 242.8 352.8 384 479.2 384z'
      
    ]
  };

  

  
  

  var faMagnifyingGlassPlus = {
    prefix: 'far',
    iconName: 'magnifying-glass-plus',
    icon: [
      512,
      512,
      ["search-plus"],
      'f00e',
      
      'M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9L471 505c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L371.1 337.1C399.2 301.7 416 256.8 416 208 416 93.1 322.9 0 208 0S0 93.1 0 208 93.1 416 208 416zm0-304c-13.3 0-24 10.7-24 24l0 48-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-48c0-13.3-10.7-24-24-24z'
      
    ]
  };

  
    var faSearchPlus = faMagnifyingGlassPlus;
  

  
  

  var faMessage = {
    prefix: 'far',
    iconName: 'message',
    icon: [
      512,
      512,
      ["comment-alt"],
      'f27a',
      
      'M203.7 512.9s0 0 0 0l-37.8 26.7c-7.3 5.2-16.9 5.8-24.9 1.7S128 529 128 520l0-72-32 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l320 0c53 0 96 43 96 96l0 224c0 53-43 96-96 96l-120.4 0-91.9 64.9zm64.3-104.1c8.1-5.7 17.8-8.8 27.7-8.8L416 400c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48L96 80c-26.5 0-48 21.5-48 48l0 224c0 26.5 21.5 48 48 48l56 0c10.4 0 19.3 6.6 22.6 15.9 .9 2.5 1.4 5.2 1.4 8.1l0 49.7c32.7-23.1 63.3-44.7 91.9-64.9z'
      
    ]
  };

  
    var faCommentAlt = faMessage;
  

  
  

  var faNoteSticky = {
    prefix: 'far',
    iconName: 'note-sticky',
    icon: [
      448,
      512,
      [62026,"sticky-note"],
      'f249',
      
      'M240 432L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0c8.8 0 16 7.2 16 16l0 176-88 0c-39.8 0-72 32.2-72 72l0 88zM380.1 320L288 412.1 288 344c0-13.3 10.7-24 24-24l68.1 0zM0 416c0 35.3 28.7 64 64 64l197.5 0c17 0 33.3-6.7 45.3-18.7L429.3 338.7c12-12 18.7-28.3 18.7-45.3L448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416z'
      
    ]
  };

  
    var faStickyNote = faNoteSticky;
  

  
  

  var faPen = {
    prefix: 'far',
    iconName: 'pen',
    icon: [
      512,
      512,
      [128394],
      'f304',
      
      'M36.4 353.8c4.1-14.6 11.8-27.9 22.6-38.7l294-294C366.4 7.6 384.8 0 404 0s37.6 7.6 51.1 21.2l35.7 35.7C504.4 70.4 512 88.8 512 108s-7.6 37.6-21.2 51.1l-294 294c-10.7 10.7-24.1 18.5-38.7 22.6L30.4 511.1c-8.3 2.3-17.3 0-23.4-6.2s-8.5-15.1-6.2-23.4L36.4 353.8zM386.8 55.1l-52.9 52.9 70.1 70.1 52.9-52.9c4.6-4.6 7.1-10.7 7.1-17.2s-2.6-12.6-7.1-17.2L421.2 55.1C416.6 50.6 410.4 48 404 48s-12.6 2.6-17.2 7.1zM300 141.9L92.9 349.1c-4.9 4.9-8.4 10.9-10.3 17.6l-24.1 86.9 86.9-24.1c6.6-1.8 12.7-5.4 17.6-10.3L370.1 212 300 141.9z'
      
    ]
  };

  

  
  

  var faRectangle = {
    prefix: 'far',
    iconName: 'rectangle',
    icon: [
      512,
      512,
      [9644,"rectangle-landscape"],
      'f2fa',
      
      'M448 112c8.8 0 16 7.2 16 16l0 256c0 8.8-7.2 16-16 16L64 400c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l384 0zM64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64z'
      
    ]
  };

  
    var faRectangleLandscape = faRectangle;
  

  
  

  var faRobot = {
    prefix: 'far',
    iconName: 'robot',
    icon: [
      640,
      512,
      [129302],
      'f544',
      
      'M344-8c0-13.3-10.7-24-24-24S296-21.3 296-8l0 72-104 0c-53 0-96 43-96 96l0 224c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-224c0-53-43-96-96-96l-104 0 0-72zM320 112l128 0c26.5 0 48 21.5 48 48l0 224c0 26.5-21.5 48-48 48l-256 0c-26.5 0-48-21.5-48-48l0-224c0-26.5 21.5-48 48-48l128 0zM176 360c0 13.3 10.7 24 24 24l32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0c-13.3 0-24 10.7-24 24zm112 0c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0c-13.3 0-24 10.7-24 24zm96 0c0 13.3 10.7 24 24 24l32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0c-13.3 0-24 10.7-24 24zM240 288a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm208-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 216c0-13.3-10.7-24-24-24S0 202.7 0 216L0 328c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zm568-24c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24z'
      
    ]
  };

  

  
  

  var faSquare = {
    prefix: 'far',
    iconName: 'square',
    icon: [
      448,
      512,
      [9632,9723,9724,61590],
      'f0c8',
      
      'M384 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z'
      
    ]
  };

  

  
  

  var faSquarePlus = {
    prefix: 'far',
    iconName: 'square-plus',
    icon: [
      448,
      512,
      [61846,"plus-square"],
      'f0fe',
      
      'M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM200 344l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z'
      
    ]
  };

  
    var faPlusSquare = faSquarePlus;
  

  
  

  var faSubtitles = {
    prefix: 'far',
    iconName: 'subtitles',
    icon: [
      512,
      512,
      [],
      'e60f',
      
      'M64 112c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-256c0-8.8-7.2-16-16-16L64 112zM0 128C0 92.7 28.7 64 64 64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zm104 80l160 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-160 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm256 0l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM104 304l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm144 0l160 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-160 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z'
      
    ]
  };

  



export {

  faBasketball,
  
  faBasketballBall,
  

  faCalendarDays,
  
  faCalendarAlt,
  

  faCardsBlank,
  

  faChartNetwork,
  

  faCircleXmark,
  
  faTimesCircle,
  
  faXmarkCircle,
  

  faClipboard,
  

  faClone,
  

  faCopy,
  

  faExpand,
  

  faEye,
  

  faEyeSlash,
  

  faFileCirclePlus,
  

  faGrid2,
  

  faImage,
  

  faImages,
  

  faLanguage,
  

  faMagnifyingGlassPlus,
  
  faSearchPlus,
  

  faMessage,
  
  faCommentAlt,
  

  faNoteSticky,
  
  faStickyNote,
  

  faPen,
  

  faRectangle,
  
  faRectangleLandscape,
  

  faRobot,
  

  faSquare,
  

  faSquarePlus,
  
  faPlusSquare,
  

  faSubtitles,
  

};
